import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import './invest.less';
import { useScrollHeader } from '../../../hooks';

export default function Invest({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
    {
      title: '集视医疗弱视方案临床试验初步访视结果出炉，001号患者4周基本治愈！',
      date: '2024-10-11',
      desc: '苏州集视医疗科技有限公司（以下简称“集视医疗”）于国内由复旦大学附属眼耳鼻喉科医院牵头，联合多中心开展的全球首个“基于AR技术的全年龄段弱视治疗方案的有效性和安全性”的前瞻性…',
      img: '/images/news/news2.png',
      route: '/newsInfo/amblyopiaClinical'
    },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: '/images/news/news3.png',
      route: '/newsInfo/academic'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 集视科技获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.08</span>
              </div>
              <div className="article_titleBottom">集视科技获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                苏州集视医疗科技有限公司（简称“集视医疗”）宣布完成由远毅资本独家投资的天使轮融资。资金将用于其自研的基于混合现实XR技术的视觉训练方法的研发与落地。<br />
                集视医疗成立于2020年，是一家以产学研联动为抓手，致力于常见眼病治疗与防控的整体解决方案的高新技术企业。当前公司产品已覆盖了弱视、干眼和眼末端患者的需求，并在弱视治疗领域的数字疗法形成了自主知识产权。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/invest1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                我国弱视患者比例超5%，传统遮盖疗法疗效有限，对于大龄患者接近无效。<br />
                弱视是发生在儿童时期的常见眼病，也是影响儿童视觉发育的主要眼病之一。通常是在视觉发育早期竞争发育的双眼刺激输入失去平衡引发的结果。 弱视不仅会导致最佳矫正视力下降，还会导致注视异常、色觉及暗适应异常，甚至在儿童视觉发育的敏感期和关键期引起立体视发育异常，严重影响儿童身心健康。
                <br />
                <br />
                传统遮盖治疗虽简便易行，但存在疗效有限（部分患者在长时间遮盖后仍无法达到正常视力或在遮盖治疗停止后发生一定程度的回退）、双眼功能缺陷、立体视功能受损等问题， 并且遮盖会对患儿外观及生活产生影响，可能导致自卑、不合群等群里问题，实际依从性较差，治疗效果往往难尽人意，且易复发。
                <br />
                <br />
                一般来讲，弱视治疗在12岁是一个临界点，12岁以后再治疗效果微乎其微。长久以来，在弱视临床研究领域，人们对12岁以后的弱视（在12岁前治疗失败或未得到有效治疗者）几乎不采取任何治疗措施。 弱视如得不到有效治疗，则可引起永久性视觉损失。
              </div>
              <div className="article_content-text1">牵手中科院研发基于混合现实XR技术的视觉训练方法</div>
              <div className="article_content-text">
                弱视的发病机制较为复杂，通常不仅是眼睛问题，还与视觉信息的传导与脑中枢的视觉感知有关。
                <br />
                集视医疗和中科院合作引入磁共振技术发现，弱视患者有小细胞层损伤，这类细胞主要介导精细觉、颜色，所以弱视患者的精细分辨率或视力更差。
                集视医疗首次活体完整揭示弱视患者的神经环路损害，并首次提出“双机制假说”，即在单眼状态下，有一个上行的小细胞通路的损伤，在患者双眼一起工作时，
                好的眼睛会对坏的眼睛有一个强的抑制作用，从而加重损伤。
                <br />
                <br />
                基于以上理论，集视医疗联合国内知名眼科临床专家联合研发了基于混合现实XR技术的视觉训练方法，通过特定的图像刺激算法重新激活弱视患者的细胞层修复，
                从而实现弱视的视力恢复，且效果面向全年龄段有效，是弱视领域的重大突破。
                <br />
                该视觉训练方案主要包含两方面，一方面是硬件的革新，利用一些日常情景，比如佩戴混合现实XR眼镜进行自由学习、工作、吃饭等，不影响正常生活，大大提高患者的依从性；
                另一方面是训练机制的革新，联合双眼推拉训练，针对双机制损伤训练，可替代传统遮盖疗法治疗大龄儿童和成人弱视甚或达到治愈的目的。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/invest2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                对于本次融资，集视医疗创始人童晓煜表示：“集视医疗将高分辨率功能磁共振引入青光眼、弱视等神经性眼病机制研究解决临床问题，未来我们也将研发多项应用于眼病诊疗的新范式。
                我们希望可以利用科研手段更真实客观的揭示疾病机制，破解临床诊疗难题，同时将研究成果转化为创新性技术，依据市场落地产品，依据患者使用和恢复情况不断调整技术形态，
                形成完整闭环。集视医疗未来还会瞄准和布局更多的眼科赛道，结合脑认知和临床研究解决更多复杂问题。”
                <br />
                远毅资本投资副总裁李阳先生表示：“集视医疗由全球领先的脑科学、眼科临床、可穿戴技术深度融合的产学研团队组成，结合脑科学深入研究眼科相关疾病的发病机制并设计针对性诊疗范式，
                开发基于可穿戴设备、符合临床路径、个性化、高依从性的诊疗产品。从成人弱视切入，未来拓展到低视力、青光眼、干眼等全方位眼健康数字化管理，全面提升眼科治疗的整体水平，
                改善患者的生活质量，弥补当前眼科治疗的短板。”
              </div>
              <div className="article_content-text1">关于远毅资本</div>
              <div className="article_content-text">
                远毅资本成立于2016年，是一家专注于数字医疗技术领域的早期风险投资基金。目前，管理的多支人民币和美元基金累计投资管理规模超过30亿人民币。
                <br />
                远毅深耕数字医疗早期和增长期的投资机会，在数字医疗的高效触达、创新支付以及效率提升这三大基础设施方面实现前瞻性布局。
                远毅资本已在拥有核心技术和创新商业模式的医疗器械和设备、精准诊断、移动医疗和服务以及医疗保险科技公司。
                近几年投资的项目主要包括AI医学影像龙头数坤科技，医疗创新支付领导者镁信健康，齿科3D打印设备公司迅实科技，医疗器械B2B流通平台贝登医疗，五官科介入器械企业莱诺医疗等。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/bestEnterprise'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/bestEnterprise'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className="PreA_marginMobile">
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className="article_rightType-block">
              <div className='PreA_right-item flex_center'>公司资讯</div>
              <div className='PreA_right-item flex_center'>最新资讯</div>
            </div>
          </div>
          <div className="article_rightMore">
            <div className='fz_18 fw_500 lh_21'>更多资讯</div>
            <div className="mt_16">
              <div className="of_hidden">
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>最新资讯</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className="PreA_right-btnBlock">
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/companyNews'))}
              >
                全部资讯
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
